import React, { Component }  from 'react';
import CountUp from 'react-countup';
import './app-footer.css';

import InternalService from '../../services/internal-api';

export default class AppFooter extends Component {

  stampsData = new InternalService();
  svenssons = `${this.stampsData._clientBase}svenssons.jpeg`;

  state = {
    specimensCount: 0,
    recordsman: null
  };

  componentDidMount() {
    this.stampsData.getSpecimensCount()
      .then((body) => {
        this.setState({
            specimensCount: body.data["count(1)"],
        });
      });

    this.stampsData.getAttributionsCount()
      .then((body) => {
        this.setState({
            recordsman: body.data,
        });
      });  
  }

  render() {

    const {specimensCount, recordsman } = this.state;
    if ((!specimensCount) || (!recordsman)) {
        return (
          <h3>Loading.</h3>
        )
      }

    const recordsmanLink = `/person/${recordsman['id']}`;

    return (
    <footer className="footer-section">
        <div className="container">
            <div className="footer-content pt-5 pb-5">
                <div className="row">
                    <div className="col-xl-4 col-lg-4">
                        <div className="footer-widget">
                            <div className="footer-logo">
                                <a href="/"><img src={this.svenssons} className="img-fluid" alt="logo" /></a>
                            </div>
                            <div className="footer-text">
                                <p>We are running the service with the support of Svensson's foundation.</p>
                            </div>
                            <div className="footer-social-icon">

                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-5">
                        <div className="footer-widget">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><a href="/publications">Bibliography</a></li>                                
                                <li><a href="/about">About the system</a></li>
                                <li><a href="/genealogy">Genealogy</a></li>
                                <li><a href="/features">New features</a></li>
                                <li><a href="/stats">Geography</a></li>
                                <li><a href="/editorial">Editorial guidelines</a></li> 
                                <li><a href="/iconography">Iconography</a></li> 
                                <li><a href="/offline">kievan-rus.offline</a></li> 
                                <li><a href="/paleography">Paleography</a></li>
                                <li><a href="/indefinable">Identify a seal!</a></li>
                                <li><a href="/emitters">Onomasticon</a></li> 
                            </ul>
                        </div>
                        <div className="footer-widget">
                            <br/>
                            <div className="footer-widget-heading">
                                <h4>Famous Collections</h4>
                            </div>
                            <ul>
                                <li><a href="/collection/1">Sheremetievs’ Family Museum</a></li>
                                <li><a href="/collection/2">Dumbarton Oaks</a></li>                                
                                <li><a href="/collection/4">Novgorod Museum-Reserve</a></li>
                                <li><a href="/collection/3">National Museum of Poland</a></li>
                            </ul>
                        </div>
                    </div>
                    {
                    <div className="col-xl-3 col-lg-3 col-md-6 centered">
                        Seals in the database
                        <br />
                    <CountUp
                        className="numbers"
                        start={specimensCount*0.995}
                        end={specimensCount}
                        duration={20}
                        useEasing={true}
                        useGrouping={true}
                        separator=" "
                        decimals={0}
                    />
                    <br /><br />
                        The largest number of attributed types <br /> 
                        <a href={recordsmanLink}>{recordsman['name_en']}</a>
                        <br />
                    <CountUp
                        className="numbers"
                        start={0}
                        end={recordsman['cnt']}
                        duration={8}
                        useEasing={true}
                        useGrouping={true}
                        separator=" "
                        decimals={0}
                    />
                    </div>}
                </div>
            </div>
        </div>
        <div className="copyright-area">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-6 text-center text-lg-left">
                        <div className="copyright-text">
                            <p>
                                &copy; <a href="https://kievan-rus.online/">Seals of Ancient Rus'</a>; Authors of <a href="/publications">publications</a>, 2023-2026
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    )
  }
}